import { LOCAL_STORAGE_KEY, SESSION_STORAGE_KEY, MEETUP_DATE } from 'define';

export function getCDNUrl(path) {
  return `https://static.andersenlab.com/${path}`;
}

export const pushCustomEvent = (event, options = {}) => {
  const preparedEventName = event.replace(/[\s-]+/g, '_');
  window.dataLayer.push({
    event: `ndrsn_${preparedEventName}`,
    ...options,
  });
};

export const pushCookiePolicyEvent = () =>
  window.dataLayer.push({
    event: 'cookie_policy_update',
  });

export const pushCustomSubmitEvent = formID =>
  window.dataLayer.push({
    event: 'custom_submit_true',
    category: 'custom_submit_true',
    'gtm.elementId': `url: ${window.location.href}; formID: ${formID};`,
  });

export const getEntryPointsFromStorages = point => {
  if (point === 'first') {
    return { firstPoint: window.localStorage.getItem(LOCAL_STORAGE_KEY) };
  }

  if (point === 'session') {
    return { sessionPoint: window.sessionStorage.getItem(SESSION_STORAGE_KEY) };
  }

  return {
    firstPoint: window.localStorage.getItem(LOCAL_STORAGE_KEY),
    sessionPoint: window.sessionStorage.getItem(SESSION_STORAGE_KEY),
  };
};

export const getMeetupDateString = () => {
  const [year, month, day] = MEETUP_DATE.split('-').map(Number);

  // Create a UTC date at 12:00 to avoid timezone shifts
  const dateObj = new Date(Date.UTC(year, month - 1, day, 12, 0, 0));

  return dateObj.toLocaleDateString('en-US', {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC',
  });
};

export const getReferrer = () => {
  const referrer = document.referrer;

  if (!referrer) {
    return 'direct';
  }

  return referrer;
};

export const isPastMeetup = () => {
  const meetup = new Date(MEETUP_DATE);
  const today = new Date();

  meetup.setHours(0, 0, 0, 0);
  today.setHours(0, 0, 0, 0);

  return meetup < today;
};

export const handleFormError = async (data, errorMessage) => {
  const localhost = process.env.NODE_ENV === 'development';

  if (localhost || !data.form) return;

  const gclid = window.localStorage.getItem('gclid');

  const payload = {
    ...data,
    ...getEntryPointsFromStorages(),
    lastPoint: window.location.href,
    referrer: getReferrer(),
    gclid,
    errorMessage,
  };

  await fetch(`${process.env.GATSBY_GOOGLE_SCRIPT_URL}?action=addRow`, {
    method: 'POST',
    body: JSON.stringify(payload),
    redirect: 'follow',
    mode: 'no-cors',
  });
};

export const cleanPhoneNumber = phone => {
  const startsWithPlus = phone.startsWith('+');
  const digitsOnly = phone.replace(/\D/g, '');

  return startsWithPlus ? '+' + digitsOnly : digitsOnly;
};
